export const USER_IN_CREW_ERROR_CODE = 'USER_IN_CREW';
export const USER_HAS_DEVICES_ERROR_CODE = 'USER_HAS_DEVICES';
export const USER_IS_ADMIN = 'USER_IS_ADMIN';
